export enum LinkedinShowProfilePhotoErrorName {
  NO_PROFILE_PHOTO = 'NO_PROFILE_PHOTO',
  NO_FORM = 'NO_FORM',
}
export class LinkedinShowProfilePhotoError extends Error {
  constructor(message: string, name: LinkedinShowProfilePhotoErrorName) {
    super(message)
    this.name = name
  }
}
